import {Link, useLocation} from "react-router-dom";
import React from "react";
import {SLIDESHOW_KEY} from "./Slideshow";

export const NavBar = ({setShouldPlay}) => {
    const location = useLocation();
    if (location.pathname.startsWith("/slideshow/") || location.pathname.startsWith("/grid/")) {
        return null;
    }

    const titleStyle = {
        fontSize: 'clamp(2.5rem, 10vw, 6rem)',
        margin: 0,
        marginTop: '0.5rem',
        marginBottom: 0
    };

    const subtitleStyle = {
        marginTop: '0.5rem',
        marginBottom: 0,
        fontSize: 'clamp(1rem, 3vw, 1.5rem)'
    };

    const noteStyle = {
        fontSize: 'clamp(2rem, 8vw, 2.5rem)'
    };

    return (
        <header className="black-80 tc pt4 quicksand-medium" style={{backgroundColor: 'transparent'}}>
            <h1 className="mt2 mb0 the-cartel i fw1 black" style={titleStyle}>Simone&Hunter</h1>
            <h2 className="mt2 mb0 f6 fw4 ttu tracked black" style={subtitleStyle}>Married May 6th 2023</h2>
            <nav className="tc mw7 center mt4">
                <Link className="cta-shake link bg-animate black hover-bg-light-gray dib pa3 ph4-l" to={`/slideshow/${SLIDESHOW_KEY}`} onClick={() => setShouldPlay?.(true)} style={{...noteStyle, background: 'linear-gradient(to right, rgba(255, 255, 255, 0.6), rgba(212, 237, 233, 0.6))', padding: '0.5rem 1rem', backdropFilter: 'blur(20px)', display: 'inline-block'}}>
                    ▶️ 🎵
                </Link>
                {/*<Link className="f6 f5-l link bg-animate black-80 hover-bg-light-pink dib pa3 ph4-l" to="/about">*/}
                {/*    {`About`}*/}
                {/*</Link>*/}
                {/*<Link className="f6 f5-l link bg-animate black-80 hover-bg-light-yellow dib pa3 ph4-l" to="/contact">*/}
                {/*    {`Contact`}*/}
                {/*</Link>*/}
            </nav>
        </header>
    );
}